export enum SessionExpirationPopupStatus {
  Default = 'default',
  Expired = 'expired',
  Hidden = 'hidden'
}
